<template>
  <div class="mimput col-md-12 p-0">
    <div class="form-group col-md-12" :class="'col-lg-'+col">
      <div class="col-md-4 mimput-label" :class="'col-lg-'+labelCol">{{label}}</div>
      <div class='col-md-8 m-0' :class="'col-lg-'+contentCol">
        <div class="row">
          <slot></slot>
          <span v-show="errBool" class="errText-wrapper">
            <i class='glyphicon glyphicon-remove-circle errText'>{{errTexrt}}</i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    errTexrt: {
      type: String,
      default: ""
    },
    errBool: {
      type: Boolean,
      default: false
    },
    col: {},
    labelCol: {
      default: "2"
    },
    contentCol: {
      default: "10"
    }
  }
}
</script>

<style lang="scss" type="text/scss">
.mimput{
  .form-group {
    position: relative;
    margin-bottom: 32px;
    padding-left: 0;
    .m-0{
      margin: 0 !important;
    }
    .mimput-label{
      height: 36px;
      line-height: 36px;
    }
    label {
      line-height: 40px;
      position: absolute;
      padding: 0;
      color: #000;
    }
    .inputbox {
      margin-left: 110px;
      position:relative;
      input[type='file'] {
        border: none;
        position: relative;
        z-index:99;
      }
      .row {
        position: relative;
        width: 100%;
        padding: 0 10px;
        .help-block {
          position: absolute;
          top:30px;
          &.passwordTip{
            top:-2px;;
            left:20px;
            z-index:0;
          }
          .false {
            color: #f44336;
            font-size: 12px;
            &:before {
              position: relative;
              top: 1px;
              margin-right: 5px;
            }
          }
        }
        span.file-help-block {
          position: absolute;
          top: 39px;
        }
        label.file-uploads {
          background: #eee;
          padding-left: 10px;
          padding-right: 10px;
          cursor: pointer;
          &:hover {
            background: #ccc;
          }
        }
        .fileName {
          position: absolute;
          min-width: 100px;
          max-width: 100px;
          height: 50px;
          top: -5px;
          left: 150px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// mimput.vue?665b3610